import { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { filterRecordsByHour, filterRecordsByRanges, makeCamerasURL, setFilterHour, setPlayList } from "../store/dataSlice"
import { Segment } from "components/ui"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { HiOutlineClock, HiOutlineOfficeBuilding } from "react-icons/hi"
import moment from "moment"

export const optionHours = [
    { id: 5, key: 'store', label: 'store_alias' },
    { id: 4, key: 'all', label: 'Todos', from: "00:00", to: "23:59" },
]

export const DAYS_MAP = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
}

const MARGIN_MINUTES = 60

const addMinutes = (time, minutes) => {
    const [h, m] = time.split(':').map(Number)
    const total = h * 60 + m + minutes
    const clamped = Math.max(0, Math.min(total, 23 * 60 + 59))
    return `${String(Math.floor(clamped / 60)).padStart(2, '0')}:${String(clamped % 60).padStart(2, '0')}`
}

/** Retorna los rangos con ±30 min de margen para filtrar records */
export const getStoreHoursForDate = (openhours, date) => {
    if (!openhours || !date) return null
    const dayOfWeek = DAYS_MAP[moment(date).day()]
    const hours = openhours[dayOfWeek]
    if (!hours || hours.length === 0) return null
    return hours.map(range => {
        const [from, to] = range.split('-')
        return [addMinutes(from, -MARGIN_MINUTES), addMinutes(to, MARGIN_MINUTES)]
    })
}

/** Retorna los rangos originales sin margen (para mostrar en UI) */
const getRawStoreHours = (openhours, date) => {
    if (!openhours || !date) return null
    const dayOfWeek = DAYS_MAP[moment(date).day()]
    const hours = openhours[dayOfWeek]
    if (!hours || hours.length === 0) return null
    return hours.map(range => range.split('-'))
}

const SelectHour = ({ size = 'sm' }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { t } = useTranslation()

    const { filter, query, records, store } = useSelector(s => s.camerasStoreData.data)
    const { list } = records
    const { storeSelected } = store

    const storeHours = useMemo(() =>
        getStoreHoursForDate(storeSelected?.openhours, filter?.date),
        [storeSelected?.openhours, filter?.date]
    )

    const displayHours = useMemo(() =>
        getRawStoreHours(storeSelected?.openhours, filter?.date),
        [storeSelected?.openhours, filter?.date]
    )

    const isStoreSelected = filter.hour?.id === 5

    const onChangeHour = (data) => {
        const hour = optionHours.find(h => h.id === data)

        let newPlaylist
        if (hour.key === 'store') {
            if (!storeHours) return
            newPlaylist = filterRecordsByRanges(list, storeHours)
        } else {
            const { from, to } = hour
            newPlaylist = filterRecordsByHour(list, from, to)
        }

        const record = newPlaylist[0]?.id ?? false
        dispatch(setFilterHour(hour))
        dispatch(setPlayList(newPlaylist))
        navigate(makeCamerasURL({ ...query, record: record, seconds: false }))
    }

    return (
        <div>
            <Segment
                className="flex justify-center flex-wrap"
                onChange={d => onChangeHour(d[0])}
                size={size}
                value={[filter.hour.id]}
            >
                {optionHours.map(o => (
                    <Segment.Item
                        key={o.id}
                        value={o.id}
                        disabled={o.key === 'store' && !storeHours}
                    >
                        <span className="flex items-center gap-1">
                            {o.key === 'store' && <HiOutlineOfficeBuilding />}
                            {o.key === 'store' ? t(o.label) : o.label}
                        </span>
                    </Segment.Item>
                ))}
            </Segment>

            {displayHours && (
                <div className={`flex items-center justify-center gap-2 mt-2 text-xs ${isStoreSelected ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-400'} transition-colors`}>
                    <HiOutlineClock className="flex-shrink-0" />
                    <span>
                        {displayHours.map(([from, to], i) => (
                            <span key={i}>
                                {i > 0 && <span className="mx-1">|</span>}
                                {from} - {to}
                            </span>
                        ))}
                    </span>
                </div>
            )}

            {!displayHours && storeSelected && (
                <p className="text-center text-xs text-red-400 mt-2">
                    {t('closed') ?? 'Cerrado'}
                </p>
            )}
        </div>
    )
}
export default SelectHour
